import { actionClient } from "@/api";
const _formatSpecs = (specs) => {
  const items = [];
  specs.forEach((item) => {
    items.push({
      activityProductId: item.activityProductId,
      number: item.number,
    });
  });
  return items;
};
export default {
  namespaced: true,

  state: {
    cart:
      JSON.parse(
        localStorage.getItem(`cart${localStorage.getItem("activityId")}`)
      ) || [],
    cartInfo: {},
  },

  mutations: {
    setCart(state, { cart }) {
      state.cart = cart;
      if (cart === null) {
        localStorage.removeItem(`cart${localStorage.getItem("activityId")}`);
      } else {
        localStorage.setItem(
          `cart${localStorage.getItem("activityId")}`,
          JSON.stringify(cart)
        );
      }
    },
    initCart(state, activityId) {
      state.cart =
        JSON.parse(localStorage.getItem(`cart${activityId}`) || null) || [];
    },
    setCartInfo(state, cartInfo) {
      state.cartInfo = cartInfo;
    },
  },

  getters: {
    cartNum: ({ cart }) => {
      let cartNum = 0;
      for (let i in cart) {
        cartNum += cart[i].number;
      }
      return cartNum;
    },
    totalPrice: ({ cart }) => {
      let totalPrice = 0;
      for (let i in cart) {
        totalPrice += cart[i].number * cart[i].salePrice;
      }
      return totalPrice;
    },
  },

  actions: {
    // 商品加入购物车
    //TODO:限购优化
    async add({ commit, state, rootState }, { productInfo, num }) {
      let cart = state.cart;
      //判断活动是否过期
      let activity = rootState.activity.activity;
      let activityStart = activity.dateFrom;
      let activityEnd = activity.dateTo;
      activityStart = Date.parse(activityStart.replace(/-/g, "/"));
      activityEnd = Date.parse(activityEnd.replace(/-/g, "/"));
      let timeNow = Date.parse(new Date());

      if (timeNow < activityStart) {
        throw new Error("添加购物车失败，活动暂未开始。");
      } else if (timeNow > activityEnd) {
        throw new Error("添加购物车失败，活动已结束。");
      }

      const photos = productInfo.productSpec.photos;

      const product = {
        productSpecId: productInfo.productSpec.id,
        activityProductId: productInfo.id,
        productName: productInfo.product.productName,
        sku: productInfo.productSpec.sku,
        salePrice: productInfo.price,
        image: photos.length > 0 ? photos[0].url : "",
        number: num,
        mark: productInfo.mark,
      };

      let oldIndex = cart.findIndex((cartInfo) => {
        return cartInfo.activityProductId == product.activityProductId;
      });

      const oldNumber = oldIndex > -1 ? cart[oldIndex].number : 0

      if (productInfo.stock <= 0 || (oldNumber + num > productInfo.stock )) {
        throw new Error("添加购物车失败，商品库存不足。");
      }

      if (oldIndex < 0) {
        cart.push(product);
      } else {
        cart[oldIndex].number += num;
      }
      commit("setCart", { cart });
    },
    async updateCartItem({ commit, rootState }, { items }) {
      if (items.length) {
        const result = await actionClient.post("member/personal/flow", {
          activityId: rootState.activity.activityId,
          items,
        });
        commit("setCart", { cart: result.items });
        commit("setCartInfo", result);
        return result;
      } else {
        commit("setCart", { cart: [] });
        commit("setCartInfo", {});
      }
    },
    //  更新产品数量
    async update({ state, dispatch }, { id, num }) {
      let cart = state.cart;
      let oldIndex = cart.findIndex((cartInfo) => {
        return cartInfo.activityProductId == id;
      });
      if (oldIndex >= 0) {
        if (num > 0) {
          cart[oldIndex].number = num;
        } else {
          cart.remove(oldIndex);
        }
      }
      const items = _formatSpecs(cart);
      dispatch("updateCartItem", { items });
    },

    //删除指定产品
    del({ dispatch, state }, id) {
      let cart = state.cart;
      let oldIndex = cart.findIndex((cartInfo) => {
        return cartInfo.activityProductId == id;
      });
      if (oldIndex >= 0) {
        cart.splice(oldIndex, 1);
      }
      const items = _formatSpecs(cart);
      dispatch("updateCartItem", { items });
    },

    //清空购物车
    clear({ commit }) {
      commit("setCart", { cart: [] });
    },
  },
};
